module.exports = __webpack_public_path__ + "media/images/article/2021_01-2ac4e73349390726114bd94198c3f4e2.png";